/**
 * Homepage Filters
 * Simplified filter system for homepage search that redirects to /autoturisme
 * Make/model dependency, URL building with slugs in path and IDs in query params
 * Uses Slim Select for all select dropdowns
 */
const HomepageFilters = (function () {
    "use strict";

    let nomenclatures = {};
    let baseUrl = "/autoturisme";

    // Slim Select instances
    let makersSlim = null;
    let modelsSlim = null;
    let fuelSlim = null;
    let gearSlim = null;

    async function init() {
        const form = document.getElementById("homepage-filters-form");
        if (!form) return;

        baseUrl = form.dataset.baseUrl || "/autoturisme";

        // Homepage always uses "autoturisme" class
        nomenclatures = await NomenclatureService.get("autoturisme");

        initSlimSelect();
        initFormSubmit();
    }

    function initSlimSelect() {
        if (typeof SlimSelect === "undefined") return;

        // Makers
        const makersEl = document.querySelector("#hp-makers-select");
        if (makersEl) {
            makersSlim = new SlimSelect({
                select: "#hp-makers-select",
                settings: {
                    showSearch: true,
                    searchPlaceholder: "Caută",
                    closeOnSelect: false,
                    allowDeselect: true,
                    placeholderText: "Marca",
                },
                events: {
                    afterChange: handleMakersChange,
                },
            });
        }

        // Models
        const modelsEl = document.querySelector("#hp-models-select");
        if (modelsEl) {
            modelsSlim = new SlimSelect({
                select: "#hp-models-select",
                settings: {
                    showSearch: true,
                    searchPlaceholder: "Caută",
                    closeOnSelect: false,
                    allowDeselect: true,
                    placeholderText: "Model",
                },
                events: {
                    afterChange: () => updateSelectionCount(modelsSlim, 'hp-models-select'),
                },
            });
            if (modelsEl.disabled) {
                modelsSlim.disable();
            }
        }

        // Fuel
        const fuelEl = document.querySelector("#hp-fuel-select");
        if (fuelEl) {
            fuelSlim = new SlimSelect({
                select: "#hp-fuel-select",
                settings: {
                    showSearch: true,
                    searchPlaceholder: "Caută",
                    closeOnSelect: false,
                    allowDeselect: true,
                    placeholderText: "Combustibil",
                },
                events: {
                    afterChange: () => updateSelectionCount(fuelSlim, 'hp-fuel-select'),
                },
            });
        }

        // Gearbox
        const gearEl = document.querySelector("#hp-gear-select");
        if (gearEl) {
            gearSlim = new SlimSelect({
                select: "#hp-gear-select",
                settings: {
                    showSearch: false,
                    allowDeselect: true,
                    placeholderText: "Cutie de viteze",
                },
            });
        }
    }

    function updateSelectionCount(slimInstance, selectId) {
        const selected = slimInstance.getSelected();
        const container = document.querySelector(`#${selectId}`)
            .closest('.custom-select--slim')
            .querySelector('.ss-values');

        // Remove existing count badge
        const existingBadge = container.querySelector('.ss-value-count');
        if (existingBadge) existingBadge.remove();

        // Add count badge if more than 1 selected
        if (selected.length > 1) {
            const badge = document.createElement('span');
            badge.className = 'ss-value-count';
            badge.textContent = `+${selected.length - 1}`;
            container.appendChild(badge);
        }
    }

    function handleMakersChange(info) {
        const selected = info.map((item) => item.value);

        // Update selection count badge
        updateSelectionCount(makersSlim, 'hp-makers-select');

        if (selected.length === 1) {
            const makeId = parseInt(selected[0]);
            const make = (nomenclatures.makes || []).find((m) => m.id === makeId);

            if (make && make.models) {
                const modelData = make.models.map((model) => ({
                    text: model.name,
                    value: String(model.id),
                    data: { slug: model.slug },
                }));
                modelsSlim.setData([
                    { placeholder: true, text: "Model" },
                    ...modelData,
                ]);
                modelsSlim.enable();
            }
        } else {
            modelsSlim.setData([{ placeholder: true, text: "Model" }]);
            modelsSlim.disable();
        }
    }

    function initFormSubmit() {
        $("#homepage-filters-form").on("submit", function (e) {
            e.preventDefault();
            window.location.href = buildUrl();
        });
    }

    function buildUrl() {
        let url = baseUrl;
        const params = {};

        // Makes (slugs in path for SEO)
        const makerSlugs = getMakerSlugs();
        if (makerSlugs.length) {
            url += "/" + makerSlugs.join(",");

            // Models (only if makers selected, slugs in path)
            const modelSlugs = getModelSlugs();
            if (modelSlugs.length) {
                url += "/" + modelSlugs.join(",");
            }
        }

        // Other filters as query params
        addParam(params, "fuel_id", getSelectedIds(fuelSlim));
        addParam(params, "gearbox_id", getSelectedValue(gearSlim));
        addParam(params, "salespricemin", $('[name="salespricemin"]').val());
        addParam(params, "salespricemax", $('[name="salespricemax"]').val());
        addParam(params, "rollingkmmax", $('[name="rollingkmmax"]').val());
        addParam(params, "firstregistrationyearmin", $('[name="firstregistrationyearmin"]').val());

        // Build query string
        const qs = Object.entries(params)
            .filter(([_, v]) => v)
            .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
            .join("&");

        return qs ? `${url}?${qs}` : url;
    }

    function getMakerSlugs() {
        if (!makersSlim) return [];
        const selectedValues = makersSlim.getSelected();
        const selectEl = document.querySelector("#hp-makers-select");
        return selectedValues.map((val) => {
            const option = selectEl.querySelector(`option[value="${val}"]`);
            return option?.dataset?.slug || val;
        });
    }

    function getModelSlugs() {
        if (!modelsSlim) return [];
        const selectedValues = modelsSlim.getSelected();
        const data = modelsSlim.getData();
        return selectedValues.map((val) => {
            const item = data.find((d) => d.value === val);
            return item?.data?.slug || val;
        });
    }

    function getSelectedIds(slimInstance) {
        if (!slimInstance) return "";
        const selected = slimInstance.getSelected();
        return selected.length ? selected.join(",") : "";
    }

    function getSelectedValue(slimInstance) {
        if (!slimInstance) return "";
        const selected = slimInstance.getSelected();
        return selected.length ? selected[0] : "";
    }

    function addParam(obj, key, val) {
        if (val) obj[key] = val;
    }

    return { init };
})();

$(document).ready(function () {
    HomepageFilters.init();
});
